import styled from '@emotion/styled'
import tw from 'twin.macro'

export const Background = styled.div`
  ${tw`
    bg-transparent
    flex 
    flex-col
    space-y-8
  `}
`

export const Header = styled.div`
  ${tw`
    flex
    flex-col
    space-y-6
    md:space-y-0
    md:flex-row
    justify-between
    text-xs 
    md:text-sm 
    leading-5 
  `}
`

export const Author = styled.div`
  ${tw`
    flex-shrink-0
  `}
  img {
    ${tw`
      h-12
      w-12
      rounded-full
    `}
  }
`

export const Title = styled.div`
  ${tw`
    md:mt-6
    md:pr-16
    leading-tight
    md:leading-none
    text-4xl
    font-bold
    text-purple-900
  `}
`

export const TitleAndDescription = styled.div`
  ${tw`
    flex
    flex-col
    md:pr-16
  `}
`

export const Body = styled.div`
  ${tw`
    flex
    flex-col
    md:flex-row
    justify-between
  `}
`

export const Description = styled.div`
  ${tw`
  py-6
  md:h-48
  `}
  p {
    ${tw`
      text-base
      text-purple-300
    `}
  }
  div {
    ${tw`
      mt-3
      font-bold
      text-indigo-600
      hover:text-indigo-500
    `}
  }
`

export const ImageCard = styled.figure`
  ${tw`
    flex-shrink-0
    w-full
    md:w-1/2
  `}
  img {
    ${tw`
      rounded-lg
      shadow-2xl
      object-cover
    `}
  }
`

export const BadgeAndDate = styled.div`
  ${tw`
    md:inline-flex
    md:items-center
  `}
  p {
    ${tw`
      pt-2
      md:pt-0
      pl-2
      text-gray-500
      hover:text-gray-400
    `}
  }
`
